// extracted by mini-css-extract-plugin
export default {"DashboardCardCover":"dashboardCard_DashboardCardCover__dQLU1","svgCover":"dashboardCard_svgCover__iPydY","textCoverSection":"dashboardCard_textCoverSection__8ybj6"};